import { type MutationError, trpc } from '@/shared/api';

interface UseDeleteFontOptions {
  readonly onSuccess?: () => void;
}

/**
 * 폰트 삭제 — 소프트 삭제다. 상품이 허용하고 있어도 지울 수 있고, 같은 요청에서 모든 상품의 허용 목록에서 빠진다.
 * 기존 디자인의 글자 모양은 그대로지만 그 폰트를 쓴 디자인은 다른 폰트로 바꿔야 다시 저장할 수 있다.
 */
export const useDeleteFont = ({ onSuccess }: UseDeleteFontOptions = {}) => {
  const mutation = trpc.productManagement.fonts.delete.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    deleteFont: mutation.mutate,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
